/**
 * EEG Seizure Reader V2 — API Client
 */

import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 300000, // 5 min for large files
});

export async function checkHealth() {
  const { data } = await api.get('/api/health');
  return data;
}

export async function getTasks() {
  const { data } = await api.get('/api/tasks');
  return data;
}

export async function getModels() {
  const { data } = await api.get('/api/models');
  return data;
}

export async function analyzeEDF(file, tasks = ['A'], modelOverrides = {}, onProgress) {
  const formData = new FormData();
  formData.append('file', file);

  const params = new URLSearchParams();
  params.set('tasks', tasks.join(','));
  if (modelOverrides.A) params.set('model_a', modelOverrides.A);
  if (modelOverrides.B) params.set('model_b', modelOverrides.B);
  if (modelOverrides.C) params.set('model_c', modelOverrides.C);

  const { data } = await api.post(`/api/analyze?${params.toString()}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => {
      if (onProgress && e.total) {
        onProgress(Math.round((e.loaded / e.total) * 100));
      }
    },
  });

  return data;
}

export default api;
